import { getRelativeDate, getWeekdayName } from '../utils/dateHelpers';

export const thisWeekHighlights = [
  {
    id: 1,
    day: getWeekdayName(0),
    date: getRelativeDate(0),
    title: 'Farmers Market',
    time: '8:00 AM - 1:00 PM',
    location: 'Downtown Roseville',
    category: 'Community',
    image: 'https://public.readdy.ai/ai/img_res/7a8a9996be67545aba8da96535c641e1.jpg'
  },
  {
    id: 2,
    day: getWeekdayName(1),
    date: getRelativeDate(1),
    title: 'City Council Meeting',
    time: '6:00 PM',
    location: 'City Hall',
    category: 'Government',
    image: 'https://readdy.ai/api/search-image?query=modern%20city%20council%20chamber%20meeting%20room%20with%20wooden%20panels%20official%20seating%20american%20flag%20professional%20government%20setting%20clean%20simple%20background&width=800&height=600&seq=thisweek2&orientation=landscape'
  },
  {
    id: 3,
    day: getWeekdayName(2),
    date: getRelativeDate(2),
    title: 'Live Music at Denio\'s',
    time: '7:00 PM - 10:00 PM',
    location: 'Denio\'s Roseville',
    category: 'Entertainment',
    image: 'https://readdy.ai/api/search-image?query=outdoor%20live%20music%20concert%20stage%20with%20band%20performing%20evening%20lights%20audience%20enjoying%20entertainment%20venue%20warm%20atmosphere%20simple%20background&width=800&height=600&seq=thisweek3&orientation=landscape'
  },
  {
    id: 4,
    day: getWeekdayName(3),
    date: getRelativeDate(3),
    title: 'Yoga in the Park',
    time: '6:30 AM',
    location: 'Maidu Park',
    category: 'Recreation',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20outdoor%20yoga%20class%20in%20park%20with%20people%20on%20mats%20morning%20sunlight%20trees%20grass%20healthy%20lifestyle%20wellness%20activity%20simple%20natural%20background&width=800&height=600&seq=thisweek4&orientation=landscape'
  },
  {
    id: 5,
    day: getWeekdayName(4),
    date: getRelativeDate(4),
    title: 'Food Truck Thursday',
    time: '5:00 PM - 9:00 PM',
    location: 'Westfield Galleria',
    category: 'Food & Drink',
    image: 'https://readdy.ai/api/search-image?query=colorful%20food%20trucks%20lined%20up%20at%20evening%20event%20with%20people%20dining%20outdoor%20seating%20festive%20lights%20delicious%20street%20food%20gathering%20simple%20background&width=800&height=600&seq=thisweek5&orientation=landscape'
  },
  {
    id: 6,
    day: getWeekdayName(5),
    date: getRelativeDate(5),
    title: 'Art Gallery Opening',
    time: '6:00 PM - 9:00 PM',
    location: 'Blue Line Arts',
    category: 'Arts & Culture',
    image: 'https://readdy.ai/api/search-image?query=elegant%20art%20gallery%20interior%20with%20paintings%20on%20white%20walls%20visitors%20viewing%20artwork%20modern%20exhibition%20space%20cultural%20event%20simple%20clean%20background&width=800&height=600&seq=thisweek6&orientation=landscape'
  },
  {
    id: 7,
    day: getWeekdayName(6),
    date: getRelativeDate(6),
    title: 'Family Movie Night',
    time: '7:30 PM',
    location: 'Mahany Park',
    category: 'Family',
    image: 'https://readdy.ai/api/search-image?query=outdoor%20movie%20night%20with%20large%20screen%20families%20sitting%20on%20blankets%20under%20stars%20evening%20park%20setting%20community%20entertainment%20simple%20background&width=800&height=600&seq=thisweek7&orientation=landscape'
  }
];